<template>
    <auth-layout>
        <header-page title="Redeem"/>
        <loading-block v-if="loading" />
        <div class="redeem-page" v-else>
            <div>
                <redeem-coin-card v-for="item in redeem" v-bind:key="item._id" :id="item._id" :log_total="item.log_total" :price="item.judul" :point="item.point" @refresh="refreshing"/>
            </div>
            <header-page title="Syarat & Ketentuan"/>
            <p>
                1. Member yang dapat menukarkan adalah member yang telah terverifikasi. <br>

                2. Member yang telah menukarkan poin/redeem point, otomatis total poin member akan terpotong sesuai dengan poin reward yang ditukarkan.<br>
                3. Member dapat melakukan penukaran selanjutnya setelah penukaran sebelumnya
                telah selesai. <br>

                4. Poin didapatkan dari artikel yang berhasil dipublikasikan di Yoursay Suara.com. <br>

                5. Proses pencairan reward dilakukan maksimal 14 hari kerja. <br>
            </p>
            <div class="mt-5">
                <header-page title="History Redeem"/>
                <div style="overflow-x:auto;">
                    <table class="table bg-white mt-3">
                        <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Title</th>
                            <th scope="col">Status</th>
                            <th scope="col">Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in histories.data" v-bind:key="item._id">
                            <th scope="row">{{item._id}}</th>
                            <td>{{item.description}}</td>
                            <td>{{item.status === 'Y' ? 'Selesai' : 'Menunggu'}}</td>
                            <td>{{moment(item.created_at)}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex mt-5">
                    <div class="mx-auto">
                        <pagination :data="histories" @pagination-change-page="getHistory" :limit="1"></pagination>
                    </div>
                </div>
            </div>
        </div>
    </auth-layout>
</template>
<style scoped>
.redeem-page {
    padding: 0 5%;
}
</style>
<script>
import axios from "axios";
import moment from "moment";

export default {
    data() {
        return {
            redeem: [],
            histories: {},
            current_page: 1,
            per_page: '',
            last_page: '',
            to: '',
            total: '',
            next_page_url: '',
            search: '',
            loading: true
        }
    },
    mounted() {
        this.getRedeem()
        this.getHistory()
    },
    methods: {
        refreshing() {
            this.getRedeem()
            this.getHistory()
        },
        getRedeem() {
            const token = this.$cookies.get('token');
            axios.get('/api/redeem', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.redeem = response.data
                    this.loading = false
                })
                .catch((error) => {

                });
        },
        async getHistory (page = 1) {
            const token = this.$cookies.get('token');
            this.loading = true;
            await axios.get(`/api/redeem/history?page=${page}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.histories = response.data
                    this.current_page = response.data.current_page
                    this.per_page = response.data.per_page
                    this.last_page = response.data.last_page
                    this.to = response.data.to
                    this.total = response.data.total
                    this.next_page_url = response.data.next_page_url
                    this.loading = false
                    window.scrollTo(0,0);
                })
                .catch((error) => {

                });
        },
        moment (date) {
            return moment(date, "YYYY-MM-DD hh:mm:ss").locale('id').format("dddd, D MMMM YYYY HH:mm");
        },
    }
}
</script>
